"use client";

import { twMerge } from "../../../helpers/tailwind-merge";
import { useDatePickerContext } from "../DatepickerContext";
import { getFormattedDate, isDateEqual, isDateInRange, Views } from "../helpers";

export interface DatepickerViewsMonthsTheme {
  items: {
    base: string;
    item: {
      base: string;
      selected: string;
      disabled: string;
    };
  };
}

export function DatepickerViewsMonth() {
  const {
    theme: rootTheme,
    minDate,
    maxDate,
    filterDate,
    selectedDate,
    viewDate,
    language,
    setViewDate,
    setView,
  } = useDatePickerContext();

  const theme = rootTheme.views.months;

  return (
    <div className={theme.items.base}>
      {[...Array(12)].map((_month, index) => {
        const newDate = new Date();
        // setting day to 1 to avoid overflow issues
        newDate.setMonth(index, 1);
        newDate.setFullYear(viewDate.getFullYear());
        const month = getFormattedDate(language, newDate, { month: "short" });

        const isSelected = selectedDate && isDateEqual(selectedDate, newDate);
        const isDisabled =
          !isDateInRange(newDate, minDate, maxDate) || (filterDate && !filterDate(newDate, Views.Months));

        return (
          <button
            disabled={isDisabled}
            key={index}
            type="button"
            className={twMerge(
              theme.items.item.base,
              isSelected && theme.items.item.selected,
              isDisabled && theme.items.item.disabled,
            )}
            onClick={() => {
              if (isDisabled) return;

              setViewDate(newDate);
              setView(Views.Days);
            }}
          >
            {month}
          </button>
        );
      })}
    </div>
  );
}

DatepickerViewsMonth.displayName = "DatepickerViewsMonth";
